import { MoreDots } from 'blaze-ui/icons/24'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { BrandKit } from 'types'
import { BrandKitMenu } from 'screens/BrandKit/BrandKitMenu/BrandKitMenu'
import { useRootStore } from 'stores/RootStore'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { BrandKitMenuDrawer } from 'screens/BrandKit/BrandKitMenuDrawer/BrandKitMenuDrawer'
import { ButtonSize } from 'blaze-ui/Button/Types'

type Props = {
  brandKit: BrandKit
  isMobile: boolean
  size?: ButtonSize
}

export const BrandKitMoreButton = ({ brandKit, isMobile, size = 'md' }: Props) => {
  const variant = isMobile ? 'editor' : 'tertiary'
  const rootStore = useRootStore()
  const { drawersStore } = rootStore
  const { openDrawer, closeDrawer } = drawersStore

  return (
    <>
      <ResponsiveDesign.Desktop>
        <MenuTrigger placement="bottom-end">
          <IconButton variant={variant} size={size} icon={MoreDots} aria-label="Brand Kit Actions" />
          <BrandKitMenu brandKit={brandKit} />
        </MenuTrigger>
      </ResponsiveDesign.Desktop>
      <ResponsiveDesign.Mobile>
        <IconButton
          variant={variant}
          size="md"
          icon={MoreDots}
          onPress={() => openDrawer(BrandKitMenuDrawer, { brandKit, onClose: closeDrawer })}
          aria-label="Brand Kit Actions"
        />
      </ResponsiveDesign.Mobile>
    </>
  )
}
